// import styles from "./assets.module.css";
import styles from "../user/user.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { IoSearch } from "react-icons/io5";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/loader";
import ReactPaginate from "react-paginate";
import "../withdraw/pagination.css";

export default function Rewardreport() {
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
    search: "",
    planName: "ALL",
    purchasedBy: "ALL",
    limit: 20,
  });

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };
  const getSubscriptionList = useCallback(async () => {
    if (!userToken) return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.rewardHistory}?page=${currentPage}&search=${parameter?.search}&fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}&rewardType=MATCHING_REWARD_BONUS&limit=${parameter.limit}&from=${parameter?.purchasedBy}`,
        { headers }
      );
      const resData = res?.data?.result[0].data;
      setLoading(false);
      setData(resData);
      setTotalPages(res?.data?.result[0].metadata[0].total_page);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
    }
  }, [currentPage, parameter, userToken]);
  useEffect(() => {
    getSubscriptionList();
  }, [getSubscriptionList]);

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Income Management</h1>
      <div className={styles?.userTopContainer}>
        <div className={styles?.userTopBoxLeft}>
          <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
            <span>Search</span>
            <div className={styles.inputBoxChild}>
              <input
                type="text"
                placeholder="Search by Username, Fullname"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, search: e.target.value });
                }}
                value={parameter?.search}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getSubscriptionList();
                  }
                }}
              />
              <IoSearch
                className={styles.inputSearchIcon}
                onClick={getSubscriptionList}
              />
            </div>
          </div>
          <div className={styles.selectBox} style={{ maxWidth: "254px" }}>
            <span>From</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    purchasedBy: e.target.value,
                  });
                }}
                value={parameter?.purchasedBy}
              >
                <option className={styles.optionMain} value={"ALL"}>
                  All
                </option>
                <option className={styles.optionMain} value={"ADMIN"}>
                  Admin
                </option>
              </select>
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
          <div className={styles.userTopBoxRight}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                setParameter({
                  page: 1,
                  fromDate: "",
                  toDate: "",
                  search: "",
                  planName: "ALL",
                  purchasedBy: "ALL",
                  limit: 20,
                });
                getSubscriptionList();
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      {/* <div className={`${styles.inputBox} ${styles.searchInputBox}`} style={{marginTop:"1rem"}}>
        <span>Total Amount</span>
        <div>
          <input
            type="text"
            className={styles.inputField}
            value={totalAmount}
          />
        </div>
      </div> */}
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            placeContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width={"100px"} height={"100px"} />
        </div>
      ) : (
        <>
          {!data || data.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </p>
          ) : (
            <div className={styles.tableWrallerUser}>
              <table>
                <tr>
                  <th>
                    {/* <input type="checkbox" className={styles.checkInputTable} /> */}
                    No.
                  </th>
                  <th>User Name</th>
                  <th>Full Name</th>
                  <th>Reward</th>
                  <th>Amount</th>
                  <th>From</th>
                  <th>Sender</th>
                  <th>Date</th>
                </tr>
                {data?.map((item, index) => {
                  return (
                    <tr>
                      <td>
                        {/* <input
                        type="checkbox"
                        className={styles?.checkInputTable}
                      /> */}
                        {index + 1 + (currentPage - 1) * parameter?.limit}
                      </td>
                      <td>
                        {item?.reciverUserName ? item.reciverUserName : "NA"}
                      </td>
                      <td>
                        {item?.firstName
                          ? item.firstName +
                            " " +
                            (item.lastName ? item.lastName : "NA")
                          : "NA"}
                      </td>
                      <td>
                        {item?.rewardType &&
                        item?.rewardType === "MATCHING_BONUS"
                          ? "RANK INCOME"
                          : item?.rewardType === "MATCHING_REWARD_BONUS"
                          ? "MATCHING REWARD"
                          : item?.rewardType.replace("_", " ")}
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span>{item?.amount.toFixed(4)} </span>
                        </div>
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span>{item?.from || "NA"} </span>
                        </div>
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <span>{item?.senderNickName || "NA"} </span>
                        </div>
                      </td>
                      <td>
                        {moment(item?.createdAt).format("DD-MM-YY | HH:mm:ss")}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}
          {(data || !data.length === 0) && (
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakClassName={"ellipsis"}
              pageClassName={"page-item"}
              previousClassName={"previous"}
              nextClassName={"next"}
              forcePage={currentPage - 1}
            />
          )}
        </>
      )}
    </div>
  );
}
